/**
 * 메타데이터 설정 권한 — Keycloak 클라이언트 role.
 *
 * | 동작                         | ADMIN | METADATA_MANAGER | METADATA_EDITOR |
 * | ---------------------------- | :---: | :--------------: | :-------------: |
 * | 설정 화면 접근 · 추가 · 수정 |   ✅   |        ✅         |        ✅        |
 * | 선택지 삭제                  |   ✅   |        ✅         |        ❌        |
 * | 기밀등급(confidential) 변경  |   ❌   |        ❌         |        ❌        |
 *
 * 분류(category) 선택지도 다른 필드와 같다 — 대분류 관리자(메타데이터 역할)가 직접 추가한다.
 *
 * 화면 노출 게이트일 뿐 — 서버도 같은 role로 검증해야 한다(규칙 #5).
 * v1 공유 상수(`shared/constants/Roles.ts`)는 건드리지 않고 v2에만 둔다.
 */
export const MetadataRole = {
  ADMIN: 'ADMIN',
  MANAGER: 'METADATA_MANAGER',
  EDITOR: 'METADATA_EDITOR',
} as const;
export type MetadataRoleType = (typeof MetadataRole)[keyof typeof MetadataRole];

/** 설정 화면 접근 · 선택지 추가 · 수정 */
export const METADATA_ACCESS_ROLES: MetadataRoleType[] = [
  MetadataRole.ADMIN,
  MetadataRole.MANAGER,
  MetadataRole.EDITOR,
];

/** 선택지 삭제 */
export const METADATA_DELETE_ROLES: MetadataRoleType[] = [
  MetadataRole.ADMIN,
  MetadataRole.MANAGER,
];

/**
 * 선택지가 서버 코드에 고정된 필드 — 누구도 설정 화면에서 바꿀 수 없다(조회만).
 * 서버 `MetadataSchemaRegistry`의 `FromEnum` 필드(기밀등급 = `ConfidentialLevel` enum)라
 * `/metadata/enums` 대상이 아니다 — 등록은 서버가 거부하고, 목록 조회는 빈 배열이 온다.
 * 스키마 응답에 이 구분이 없어 필드 이름으로 판정한다.
 */
export const METADATA_FIXED_OPTION_FIELDS: readonly string[] = ['confidential'];

/** role 표시 라벨 — 권한이 높은 순 */
export const METADATA_ROLE_LABEL: Record<MetadataRoleType, string> = {
  ADMIN: '시스템 관리자',
  METADATA_MANAGER: '메타데이터 관리자',
  METADATA_EDITOR: '메타데이터 편집자',
};
